export default function SimpleHelloReact({ name = "World" }) {
  return <h1>Hello, {name}!</h1>;
}
